import { memo } from 'react';

import { RepeatIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { useSysadmin } from './SysadminProvider';

export const SysadminClearWorkspaceButton = memo(() => {
  const { handleClearWorkspaceId, isInternal } = useSysadmin();

  // biome-ignore lint/style/useBlockStatements: PLA-1724 — pre-existing debt, not introduced by the icon migration
  if (!isInternal) return null;

  return (
    <IconButton
      appearance="ghost"
      className="bg-black text-white hover:bg-black hover:text-white active:bg-black active:text-white"
      color="gray"
      label="Switch"
      onClick={handleClearWorkspaceId}
    >
      <RepeatIcon size="sm" />
    </IconButton>
  );
});

SysadminClearWorkspaceButton.displayName = 'SysadminClearWorkspaceButton';
